import { dispatch } from '../../store';
import { addAuth } from '../../store/slices/auth.slice';
import { setNavigation } from '../../store/slices/navigation/navigation.slice';
import { UserDto } from '../../commonTypes/user.types';

export const useAddAuth = () => {
    const addUserAuth = (user: UserDto) => {
        dispatch(addAuth(user));
        dispatch(setNavigation(user.role.name));
    };

    return { addUserAuth };
};
